import ArrowIcon from '@mui/icons-material/ArrowForward'
import { Box } from '@mui/material'

import DateTooltipField from './DateTooltipField'
import { useCommonStyles } from '../config/theme'

const PeriodField = ({
  startedOnSource = 'startedOn',
  endedOnSource = 'endedOn',
  label = 'resources.common.fields.period',
  sx = {},
  ...props
}) => {
  const classes = useCommonStyles()

  return (
    <Box component="span" sx={{ ...classes.textWithSmallIcons, ...sx }}>
      <DateTooltipField {...props} source={startedOnSource} />
      <ArrowIcon sx={{ margin: '0 !important', ...sx }} />
      <DateTooltipField {...props} source={endedOnSource} />
    </Box>
  )
}

export default PeriodField
